import balansScreen from "../assets/balans-screenshot.jpg";
import quickhomeScreen from "../assets/quickhome-screenshot.jpg";
import quickhubScreen from "../assets/quickhub-screenshot.jpg";
import bottomlineScreen from "../assets/bottomline-screenshot.jpg";
import majowkowyScreen from "../assets/majowkowy-balans-screenshot.jpg";
import aptacyScreen from "../assets/aptacy-screenshot.jpg";
import gustiScreen from "../assets/gusti-screenshot.jpg";
import gustiKatalogScreen from "../assets/gusti-katalog-screenshot.jpg";
import motylekScreen from "../assets/kolorowymotylek-screenshot.jpg";

// `hidden: true` — wpis wstrzymany: nie pojawia się w portfolio, a jego adres kieruje na stronę główną.
export const CASE_STUDIES = [
  {
    slug: "szkolenia-balans",
    title: "Szkolenia Balans",
    client: "Balans",
    tag: {
      pl: "Strona firmowa · Motion Design",
      en: "Company Website · Motion Design",
    },
    excerpt: {
      pl: "Platforma szkoleniowa zaprojektowana tak, aby budować poczucie oddechu i spokoju — zamiast przypominać kolejny przeładowany system kursów.",
      en: "A training platform designed to convey space, calm and openness — rather than another overloaded course system.",
    },
    body: {
      pl: [
        "Balans potrzebowało cyfrowej przestrzeni, która oddaje charakter marki: spokój, oddech i autentyczność. Zamiast szablonowego LMS-a zaprojektowaliśmy doświadczenie, które prowadzi użytkownika bez presji.",
        "Motion design i typografia budują rytm strony. Każda sekcja ma swój oddech — animacje są celowe, nie dekoracyjne. Strona ładuje się szybko i działa płynnie na mobile.",
        "Efekt: strona, która nie tylko prezentuje ofertę, ale sama komunikuje wartości marki Balans.",
      ],
      en: [
        "Balans needed a digital space that reflects the brand: calm, breath and authenticity. Instead of a template LMS, we designed an experience that guides users without pressure.",
        "Motion design and typography build the page rhythm. Every section breathes — animations are intentional, not decorative. The site loads fast and runs smoothly on mobile.",
        "Result: a website that doesn't just present the offer, but communicates Balans brand values on its own.",
      ],
    },
    tech: ["React 19", "Framer Motion", "Canvas API", "Lenis", "FastAPI", "MongoDB", "Netlify"],
    link: "https://szkoleniabalans.pl",
    linkLabel: "szkoleniabalans.pl",
    image: balansScreen,
    accent: "#E8607A",
    meta: {
      pl: {
        title: "Case study: Szkolenia Balans — strona firmowa | Przestrzeń Apps",
        description: "Jak zaprojektowaliśmy stronę szkoleniową Balans — motion design, spokój wizualny i płynność działania.",
      },
      en: {
        title: "Case study: Szkolenia Balans — company website | Przestrzeń Apps",
        description: "How we designed the Balans training website — motion design, visual calm and smooth performance.",
      },
    },
  },
  {
    slug: "quick-home",
    title: "Quick Home",
    client: "Quick Home",
    tag: {
      pl: "Producent domów modułowych · Strona firmowa",
      en: "Modular Home Manufacturer · Company Website",
    },
    excerpt: {
      pl: "Dwa produkty, jedna strona główna — z konfiguratorem, który przelicza wycenę domu modułowego w czasie rzeczywistym, i osobną ścieżką do zabudów kamperowych QuickCabin.",
      en: "Two products, one homepage — with a configurator that recalculates the modular home price in real time, and a separate path for QuickCabin van conversions.",
    },
    body: {
      pl: [
        "Quick Home produkuje całoroczne domy modułowe i zabudowy kamperowe QuickCabin — dwa różne produkty, dwie różne grupy odbiorców. Zamiast rozdzielać je na osobne witryny, zaprojektowaliśmy jedną stronę główną podzieloną na pół: po lewej dom, po prawej kamper, każdy z własną ścieżką do oferty.",
        "Dla domów modułowych zbudowaliśmy interaktywny konfigurator wyceny: klient wybiera metraż (35, 54 lub 70 m²), typ dachu, docieplenie, okna czy zabudowę tarasu, a cena brutto przelicza się na bieżąco — razem z kosztem transportu i montażu. Gotową wycenę wysyła sobie jednym kliknięciem na WhatsApp, bez telefonowania i czekania na ofertę handlowca.",
        "Duże, premium zdjęcia produktowe niosą resztę komunikacji — tekstu jest niewiele, ale to, co zostało, mówi konkretami: metraż, cena od, czas montażu. Przełącznik PL/EN i numer telefonu są zawsze w zasięgu ręki, bez przewijania.",
        "Efekt: strona, która sprzedaje szybkość i konkret — dokładnie to, co Quick Home obiecuje swoim klientom.",
      ],
      en: [
        "Quick Home manufactures year-round modular homes and QuickCabin van conversions — two different products, two different audiences. Instead of splitting them across separate sites, we designed a single homepage split down the middle: a house on the left, a camper on the right, each with its own path to the offer.",
        "For the modular homes we built an interactive pricing configurator: the client picks the floor area (35, 54 or 70 m²), roof type, insulation, windows or terrace enclosure, and the gross price recalculates live — together with transport and assembly costs. The finished quote goes straight to WhatsApp in one click, no phone calls or waiting on a sales rep.",
        "Large, premium product photography carries the rest of the message — copy is minimal, but what's there is concrete: floor area, starting price, install time. The PL/EN switch and phone number stay within reach, no scrolling required.",
        "Result: a site that sells speed and clarity — exactly what Quick Home promises its customers.",
      ],
    },
    tech: ["React", "Tailwind CSS", "Netlify Forms", "Netlify"],
    link: "https://www.quick-home.pl/",
    linkLabel: "quick-home.pl",
    image: quickhomeScreen,
    accent: "#5B8DB8",
    meta: {
      pl: {
        title: "Case study: Quick Home — strona producenta domów modułowych | Przestrzeń Apps",
        description: "Jak zaprojektowaliśmy stronę Quick Home — konfigurator wyceny domu modułowego w czasie rzeczywistym i decyzja zakupowa bez przewijania.",
      },
      en: {
        title: "Case study: Quick Home — modular home manufacturer site | Przestrzeń Apps",
        description: "How we designed the Quick Home website — a real-time modular home pricing configurator and a purchase decision without scrolling.",
      },
    },
  },
  {
    slug: "quickhub-terminal",
    title: "QuickHub Terminal",
    client: "QuickHub Terminal Poznań",
    tag: {
      pl: "Terminal kontenerowy · Strona firmowa",
      en: "Container Terminal · Company Website",
    },
    excerpt: {
      pl: "Strona terminalu kontenerowego, która musi przekonać klienta biznesowego w kilka sekund — kontener, cena i telefon, zanim zdąży kliknąć „wstecz”.",
      en: "A container terminal site that has to convince a B2B buyer in seconds — container, price and phone number before they hit back.",
    },
    body: {
      pl: [
        "QuickHub Terminal sprzedaje, magazynuje i transportuje kontenery morskie 20'DV, 40'DV i 40'HC dla klientów biznesowych — firm budowlanych, logistycznych i importerów. To branża, w której liczy się dostępność i cena, nie estetyka, więc strona musiała działać jak przedłużenie działu handlowego, nie jak broszura.",
        "Zdjęcie terminalu nocą, twarde nagłówki i dwa równorzędne wezwania do działania — „Poproś o ofertę” i bezpośredni numer telefonu — już na pierwszym ekranie. Nawigacja prowadzi wprost do oferty, magazynowania, transportu i galerii realizacji, bez zbędnych przystanków.",
        "Efekt: strona, która generuje zapytania ofertowe zamiast czekać, aż klient sam je napisze.",
      ],
      en: [
        "QuickHub Terminal sells, stores and transports 20'DV, 40'DV and 40'HC shipping containers for B2B clients — construction, logistics and import companies. In this industry availability and price matter more than aesthetics, so the site had to work like an extension of the sales team, not a brochure.",
        "A night-time terminal photo, blunt headlines and two equally weighted calls to action — 'Request a quote' and a direct phone number — right on the first screen. Navigation goes straight to the offer, storage, transport and project gallery, with no detours.",
        "Result: a site that generates quote requests instead of waiting for the client to write one.",
      ],
    },
    tech: ["React", "Tailwind CSS", "Netlify Forms", "Netlify"],
    link: "https://quickhubterminal.pl/",
    linkLabel: "quickhubterminal.pl",
    image: quickhubScreen,
    accent: "#DD6B20",
    meta: {
      pl: {
        title: "Case study: QuickHub Terminal — terminal kontenerowy | Przestrzeń Apps",
        description: "Jak zaprojektowaliśmy stronę terminalu kontenerowego QuickHub — oferta, cena i kontakt na pierwszym ekranie.",
      },
      en: {
        title: "Case study: QuickHub Terminal — container terminal | Przestrzeń Apps",
        description: "How we designed the QuickHub Terminal website — offer, price and contact on the first screen.",
      },
    },
  },
  {
    slug: "bottomline",
    title: "Bottom Line",
    client: "Bottom Line · Biuro rachunkowe",
    tag: {
      pl: "Biuro rachunkowe · Strona firmowa",
      en: "Accounting Firm · Company Website",
    },
    excerpt: {
      pl: "Strona biura rachunkowego budująca zaufanie — bez korporacyjnego chłodu, z bezpośrednim kontaktem z księgową.",
      en: "An accounting firm website that builds trust — without corporate coldness, with direct contact with the accountant.",
    },
    body: {
      pl: [
        "Biuro rachunkowe Bottom Line potrzebowało strony, która buduje zaufanie od pierwszego wejrzenia. Stonowana, ciemna szata graficzna i jasna ścieżka kontaktu zamiast anonimowej infolinii.",
        "React, Tailwind CSS i formularz Netlify. Strona jest szybka, czytelna i dostosowana do urządzeń mobilnych.",
        "Efekt: profesjonalna obecność online, która oddaje charakter butikowego biura.",
      ],
      en: [
        "Bottom Line accounting needed a site that builds trust at first glance. A calm, dark visual identity and a clear contact path instead of an anonymous hotline.",
        "React, Tailwind CSS and Netlify form. The site is fast, readable and mobile-friendly.",
        "Result: a professional online presence that reflects a boutique accounting firm.",
      ],
    },
    tech: ["React", "Tailwind CSS", "Netlify Forms", "Netlify"],
    link: "https://bottomline.pl/",
    linkLabel: "bottomline.pl",
    image: bottomlineScreen,
    accent: "#2E4C3E",
    meta: {
      pl: {
        title: "Case study: Bottom Line — biuro rachunkowe | Przestrzeń Apps",
        description: "Strona firmowa dla biura rachunkowego Bottom Line — zaufanie, prostota i bezpośredni kontakt.",
      },
      en: {
        title: "Case study: Bottom Line — accounting firm | Przestrzeń Apps",
        description: "Company website for Bottom Line accounting — trust, simplicity and direct contact.",
      },
    },
  },
  {
    slug: "majowkowy-balans",
    hidden: true, // aplikacja zdjęta ze Sklepu Play do naprawy — usuń tę flagę (i `hidden` w Portfolio.jsx), gdy wróci
    title: "Majówkowy Balans",
    client: "Balans",
    tag: {
      pl: "Event App · Android · Offline-first",
      en: "Event App · Android · Offline-first",
    },
    excerpt: {
      pl: "Aplikacja eventowa na cztery dni wyjazdu — harmonogram, mapa tras i powiadomienia działające bez zasięgu w górach.",
      en: "An event app for a four-day retreat — schedule, trail map and notifications working offline in the mountains.",
    },
    body: {
      pl: [
        "Majówkowy Balans to wyjazd w terenie, gdzie zasięg bywa luksusem. Aplikacja musiała działać offline-first: harmonogram aktywności, mapa tras i komunikacja grupowa bez internetu.",
        "React PWA, Service Worker i backend FastAPI. Aplikacja trafiła też na Google Play jako natywny wrapper.",
        "Uczestnicy korzystali z niej przez cztery dni bez zarzutu — nawet w Bieszczadach i na Mazurach.",
      ],
      en: [
        "Majówkowy Balans is a field retreat where signal is a luxury. The app had to work offline-first: activity schedule, trail map and group communication without internet.",
        "React PWA, Service Worker and FastAPI backend. The app also shipped on Google Play as a native wrapper.",
        "Participants used it for four days flawlessly — even in the mountains.",
      ],
    },
    tech: ["React PWA", "Service Worker", "Framer Motion", "FastAPI", "Google Play"],
    link: "https://play.google.com/store/apps/details?id=pl.miloszczarnecki.balansapp&hl=pl",
    linkLabel: "Google Play",
    image: majowkowyScreen,
    accent: "#78BE44",
    meta: {
      pl: {
        title: "Case study: Majówkowy Balans — aplikacja eventowa | Przestrzeń Apps",
        description: "Aplikacja wyjazdowa offline-first dla Balans — harmonogram, mapa i powiadomienia bez zasięgu.",
      },
      en: {
        title: "Case study: Majówkowy Balans — event app | Przestrzeń Apps",
        description: "Offline-first retreat app for Balans — schedule, map and notifications without signal.",
      },
    },
  },
  {
    slug: "aptacy-nieruchomosci",
    title: "Aptacy Nieruchomości",
    client: "Aptacy Nieruchomości",
    tag: {
      pl: "Portal nieruchomości · Full-stack",
      en: "Real Estate Portal · Full-stack",
    },
    excerpt: {
      pl: "Spokojne, premium doświadczenie przeglądania ofert — zamiast chaosu typowego dla portali nieruchomości.",
      en: "A calm, premium browsing experience — instead of the chaos typical of real estate portals.",
    },
    body: {
      pl: [
        "Portal nieruchomości musi budować zaufanie od pierwszego kliknięcia. Dla Aptacy zaprojektowaliśmy interfejs, który prowadzi uwagę bez przeładowania — mapa, filtry i karty ofert w jednym spójnym systemie.",
        "Leaflet.js, responsywny layout i formularz kontaktowy Netlify. Strona działa szybko nawet przy dużej liczbie zdjęć ofert.",
        "Klienci Aptacy regularnie pytają, kto zaprojektował portal — to najlepsza referencja.",
      ],
      en: [
        "A real estate portal must build trust from the first click. For Aptacy we designed an interface that guides attention without overload — map, filters and listing cards in one coherent system.",
        "Leaflet.js, responsive layout and Netlify contact form. The site stays fast even with many listing photos.",
        "Aptacy clients regularly ask who designed the portal — that's the best reference.",
      ],
    },
    tech: ["React", "Tailwind CSS", "Leaflet.js", "Netlify Forms", "Netlify"],
    link: "https://www.aptacy-nieruchomosci.pl/",
    linkLabel: "aptacy-nieruchomosci.pl",
    image: aptacyScreen,
    accent: "#C7A35A",
    meta: {
      pl: {
        title: "Case study: Aptacy Nieruchomości — portal | Przestrzeń Apps",
        description: "Portal nieruchomości premium dla Aptacy — mapa ofert, szybkość i spokojny UX.",
      },
      en: {
        title: "Case study: Aptacy Real Estate — portal | Przestrzeń Apps",
        description: "Premium real estate portal for Aptacy — listing map, speed and calm UX.",
      },
    },
  },
  {
    slug: "gusti-di-italia",
    title: "Gusti di Italia",
    client: "Gusti D'Italia",
    tag: {
      pl: "Sklep internetowy · Delikatesy włoskie",
      en: "E-commerce · Italian Delicatessen",
    },
    excerpt: {
      pl: "Sklep bezpośredniego importera włoskich delikatesów — z autorskim motywem na Shoperze, który zamiast katalogu produktów pokazuje „kartę” smaków.",
      en: "An online store of a direct importer of Italian delicacies — with a custom Shoper theme that presents a menu of flavours instead of a plain product catalogue.",
    },
    body: {
      pl: [
        "Gusti D'Italia to bezpośredni importer włoskich serów, wędlin, słodyczy i produktów ze spiżarni. Sklep działa na platformie Shoper, więc zaprojektowaliśmy dla niego autorski motyw: czerń i złoto, szeryfowa typografia (Cormorant Garamond i Jost) oraz duże fotografie, które nadają sklepowi charakter delikatesów premium.",
        "Strona główna prowadzi jak karta w restauracji: hasło „Najlepsze włoskie smaki w jednym miejscu”, dwa równorzędne wejścia — „Przeglądaj kartę” i „Katalog prezentów” — a tuż pod nimi pasek czterech argumentów zaufania: darmowa dostawa od 200 zł, status bezpośredniego importera, zestawy prezentowe w osobnym katalogu i opinie klientów. Niżej kafelki kategorii „La carta”, każdy z własną fotografią.",
        "Wejście do katalogu prezentów to osobny projekt z tej listy, więc kto szuka prezentu, nie musi przeglądać całej karty produktów. Sklep ma też wersję mobilną — z menu, wyszukiwarką i koszykiem w zasięgu kciuka.",
        "Efekt: sklep, który wygląda jak marka premium i pozwala wejść w każdą kategorię jednym kliknięciem.",
      ],
      en: [
        "Gusti D'Italia is a direct importer of Italian cheeses, cured meats, sweets and pantry products. The store runs on the Shoper platform, so we designed a custom theme for it: black and gold, serif typography (Cormorant Garamond and Jost) and large photography that gives the store the character of a premium delicatessen.",
        "The homepage leads like a restaurant menu: the line “The best Italian flavours in one place”, two equally weighted entries — “Browse the menu” and “Gift catalogue” — and right below them a strip of four trust points: free delivery over PLN 200, direct-importer status, gift sets in a separate catalogue and customer reviews. Further down come the “La carta” category tiles, each with its own photograph.",
        "The entry to the gift catalogue is a separate project on this list, so anyone looking for a gift doesn't have to browse the whole product menu. The store also has a mobile version — with the menu, search and cart within thumb's reach.",
        "Result: a store that looks like a premium brand and lets you enter any category in a single click.",
      ],
    },
    tech: ["Shoper", "Własny motyw", "CSS", "JavaScript"],
    link: "https://gustiditalia.pl/",
    linkLabel: "gustiditalia.pl",
    image: gustiScreen,
    accent: "#C9A45C",
    meta: {
      pl: {
        title: "Case study: Gusti di Italia — sklep internetowy | Przestrzeń Apps",
        description: "Jak zaprojektowaliśmy autorski motyw sklepu Gusti D'Italia na Shoperze — czerń i złoto, karta kategorii i wejście do katalogu prezentów.",
      },
      en: {
        title: "Case study: Gusti di Italia — online store | Przestrzeń Apps",
        description: "How we designed a custom Shoper theme for the Gusti D'Italia store — black and gold, a menu of categories and an entry to the gift catalogue.",
      },
    },
  },
  {
    slug: "gusti-katalog-prezentow",
    title: "Katalog prezentów Gusti D'Italia",
    client: "Gusti D'Italia",
    tag: {
      pl: "Katalog interaktywny · Zestawy prezentowe",
      en: "Interactive Catalogue · Gift Sets",
    },
    excerpt: {
      pl: "Cyfrowy katalog zestawów prezentowych, który kartkuje się jak książka — 46 stron, 19 zestawów i jedno pytanie przy każdym: „Zapytaj o ofertę”.",
      en: "A digital gift-set catalogue you page through like a book — 46 pages, 19 sets and one question on each: “Ask for an offer”.",
    },
    body: {
      pl: [
        "Na sezon 2026 Gusti D'Italia przygotowało kolekcję 19 zestawów prezentowych. Zamiast pliku PDF zbudowaliśmy interaktywną książkę: okładka, strona powitalna i po jednej rozkładówce na każdy zestaw — ze zdjęciem, opisem, składem i ceną.",
        "Strony przewraca się strzałkami lub klawiaturą, a na telefonie katalog przechodzi w tryb pojedynczej strony. Typografia (Cormorant Garamond i Jost), miedziane ramki i ciemne tło wynikają z identyfikacji sklepu, a pierwsze skrzypce grają fotografie zestawów.",
        "Przy każdym zestawie jest przycisk „Zapytaj o ofertę”, który prowadzi do strony kontaktowej sklepu, więc oglądanie kończy się zapytaniem, a nie zamknięciem karty. Katalog otwiera się ze sklepu gustiditalia.pl i działa na Cloudflare Workers.",
        "Efekt: katalog, który wygląda jak wydawnictwo, otwiera się w ułamku sekundy i prowadzi od oglądania prezentów prosto do zapytania.",
      ],
      en: [
        "For the 2026 season Gusti D'Italia prepared a collection of 19 gift sets. Instead of a PDF we built an interactive book: a cover, a welcome page and one spread per set — with a photograph, description, contents and price.",
        "Pages turn with the arrows or the keyboard, and on a phone the catalogue switches to a single-page mode. The typography (Cormorant Garamond and Jost), copper frames and dark background follow the store's identity, while the photographs of the sets take the lead.",
        "Every set has an “Ask for an offer” button leading to the store's contact page, so browsing ends in an enquiry rather than a closed tab. The catalogue opens from the gustiditalia.pl store and runs on Cloudflare Workers.",
        "Result: a catalogue that looks like a publication, opens in a fraction of a second and leads straight from browsing gifts to an enquiry.",
      ],
    },
    tech: ["JavaScript", "page-flip", "Cloudflare Workers"],
    link: "https://gusti-katalogi.przestrzenapps.workers.dev/katalog/",
    linkLabel: "Otwórz katalog",
    image: gustiKatalogScreen,
    accent: "#D98A55",
    meta: {
      pl: {
        title: "Case study: Katalog prezentów Gusti D'Italia — katalog interaktywny | Przestrzeń Apps",
        description: "Interaktywny katalog 19 zestawów prezentowych Gusti D'Italia — 46 stron do kartkowania, ceny i zapytanie ofertowe przy każdym zestawie.",
      },
      en: {
        title: "Case study: Gusti D'Italia gift catalogue — interactive catalogue | Przestrzeń Apps",
        description: "An interactive catalogue of 19 Gusti D'Italia gift sets — 46 pages to flip through, prices and an enquiry button on every set.",
      },
    },
  },
  {
    slug: "kolorowy-motylek",
    title: "Kolorowy Motylek",
    client: "Kolorowy Motylek",
    tag: {
      pl: "Sklep internetowy · Papeteria i zabawki",
      en: "E-commerce · Stationery & Toys",
    },
    excerpt: {
      pl: "Sklep szkolno-papierniczy z Poznania, w którym zakupy do szkoły robi się jednym kliknięciem — z gotowymi zestawami i usługą „Wyprawka szkolna”.",
      en: "A stationery and toy store from Poznań where back-to-school shopping takes a single click — with ready-made kits and a “School kit” service.",
    },
    body: {
      pl: [
        "Kolorowy Motylek to sklep z artykułami szkolnymi, papierniczymi i zabawkami w Poznaniu. Zbudowaliśmy go na WordPressie i WooCommerce z autorskim motywem, żeby wygląd w pełni pasował do marki: kolorowe, zaokrąglone kafelki kategorii, czcionka Fredoka i paleta fioletu, żółci i granatu zamiast typowego szablonu sklepowego.",
        "Najważniejszy jest pomysł na zakupy. Sekcja „Gotowe komplety” (Przedszkole, Klasa 1, Klasa 4, Na przerwę) pokazuje skład i cenę całego zestawu i dodaje go do koszyka jednym kliknięciem. Dla rodziców, którzy nie chcą kompletować wyprawki sami, jest usługa „Wyprawka szkolna”: wysyłają zdjęcie listy od wychowawczyni albo plik PDF, a sklep skompletuje zamówienie — do odbioru w Poznaniu lub wysyłki kurierem InPost.",
        "Strona główna prowadzi do zakupu z kilku stron naraz: pasek z kodem rabatowym, odliczanie do początku roku szkolnego, hity sprzedaży i jasne warunki — darmowa dostawa od 200 zł, odbiór osobisty, płatności BLIK, kartą i przelewem oraz 14 dni na zwrot.",
        "Efekt: sklep, który wygląda jak zabawa, a działa jak dobrze zorganizowana papeteria — z jasną ścieżką od listy zakupów do koszyka.",
      ],
      en: [
        "Kolorowy Motylek is a store selling school supplies, stationery and toys in Poznań. We built it on WordPress and WooCommerce with a custom theme so that the look fits the brand completely: colourful, rounded category tiles, the Fredoka typeface and a palette of purple, yellow and navy instead of a typical shop template.",
        "The key is the idea behind the shopping. The “Ready-made kits” section (Preschool, Grade 1, Grade 4, For the break) shows the contents and price of a whole set and adds it to the cart in one click. For parents who don't want to assemble the school kit themselves there is the “School kit” service: they send a photo of the teacher's list or a PDF, and the store assembles the order — for pickup in Poznań or delivery by InPost courier.",
        "The homepage leads to a purchase from several angles at once: a bar with the discount code, a countdown to the start of the school year, bestsellers and clear terms — free delivery over PLN 200, in-store pickup, payment by BLIK, card or bank transfer, and 14 days to return.",
        "Result: a store that looks like play and works like a well-organised stationery shop — with a clear path from shopping list to cart.",
      ],
    },
    tech: ["WordPress", "WooCommerce", "Własny motyw", "Complianz"],
    link: "https://kolorowymotylek.pl/",
    linkLabel: "kolorowymotylek.pl",
    image: motylekScreen,
    accent: "#7B5CFF",
    meta: {
      pl: {
        title: "Case study: Kolorowy Motylek — sklep szkolno-papierniczy | Przestrzeń Apps",
        description: "Jak zbudowaliśmy sklep Kolorowy Motylek na WooCommerce — gotowe zestawy do szkoły w jednym kliknięciu i usługa „Wyprawka szkolna”.",
      },
      en: {
        title: "Case study: Kolorowy Motylek — stationery and toy store | Przestrzeń Apps",
        description: "How we built the Kolorowy Motylek store on WooCommerce — ready-made school kits in one click and a “School kit” service.",
      },
    },
  },
];

export function getCaseStudy(slug) {
  return CASE_STUDIES.find((cs) => cs.slug === slug && !cs.hidden) ?? null;
}
